import { render, staticRenderFns } from "./lc.vue?vue&type=template&id=d2c66112&scoped=true"
import script from "./lc.vue?vue&type=script&lang=js"
export * from "./lc.vue?vue&type=script&lang=js"
import style0 from "./lc.vue?vue&type=style&index=0&id=d2c66112&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c66112",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2c66112')) {
      api.createRecord('d2c66112', component.options)
    } else {
      api.reload('d2c66112', component.options)
    }
    module.hot.accept("./lc.vue?vue&type=template&id=d2c66112&scoped=true", function () {
      api.rerender('d2c66112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/lc.vue"
export default component.exports